




















import Vue, { PropType } from "vue"

type ButtonType = "main" | "key" | "disabled"

export default Vue.extend({
  props: {
    type: {
      type: String as PropType<ButtonType>,
      default: "key",
    },
    isUnclickable: {
      type: Boolean,
      default: false,
    },
    isCenterPosition: {
      type: Boolean,
      default: false,
    },
    isStaticPosition: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    hasBottomMarginForMobileNavBar: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      if (this.isUnclickable) {
        return
      }
      this.$emit("click")
    },
  },
})
